export default __webpack_public_path__ + "static/media/welpentreffen_6.5f70fc30.jpg";